"use client"
import AnalysisInfo from "@/app/homepage/common/components/AnalysisInfo";

const DetailInfo = () => {
    return (
        <AnalysisInfo />
    );
};

export default DetailInfo;
